import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../shared/components/table/table.component';
import { TableColumn } from '../../core/models/column.model';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Alert } from '../../core/models/alert.model';
import { MatTabsModule } from '@angular/material/tabs';
import { GeneralComponent } from '../general/general.component';
import { Constants } from '../../shared/utils/constants';
import { UpdateRecordService } from '../../core/services/update-record.service';
import { MatDialog } from '@angular/material/dialog';
import { UpdateRecord } from '../../core/models/update-record.model';
import { ModalComponent } from '../modal/modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { ConfirmPopupComponent } from '../../shared/components/confirm-popup/confirm-popup.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-preview',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    RouterModule,
    MatTableModule,
    MatTabsModule,
    GeneralComponent,
    ReactiveFormsModule,
    MatSnackBarModule,
    ConfirmPopupComponent,
  ],
  templateUrl: './preview.component.html',
  styleUrl: './preview.component.scss'
})

export class PreviewComponent implements OnInit {
  alerts: Alert[] = [];
  origin: string | null = null;
  recordToClone: any | null = null;
  showConfirmPopup = false;
  showClonePopup = false;
  flattenedData: { [key: string]: any[] } = {
    [Constants.NOVEDADES]: [],
    [Constants.AVISO_AVERIAS]: [],
    [Constants.OT_EJECUTADAS]: [],
    [Constants.FUERA_SERVICIO]: [],
    [Constants.SEGURIDAD]: [],
    [Constants.PERSONAL]: [],
  };

  tableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true },
    { header: 'Hora', field: 'hora' },
    { header: 'Responsable', field: 'responsable' },
    { header: 'Área', field: 'updateArea' },
    { header: 'Novedad', field: 'novedad' },
    { header: 'Fecha', field: 'fecha', isDate: true },
  ];

  constructor(
    private updateRecordService: UpdateRecordService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private snackBar: MatSnackBar,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe(params => {
      this.origin = params.get('origin');

      if (this.origin === 'shift-report') {
        this.tableColumns = [
          { header: 'Hora', field: 'hora' },
          { header: 'Área', field: 'updateArea' },
          { header: 'Contenido', field: 'novedad' },
          { header: 'Responsable', field: 'responsable' },
        ];
      } else if (this.origin === 'daily-shift') {
        this.tableColumns = [
          { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true },
          { header: 'Hora', field: 'hora' },
          { header: 'Tipo', field: 'tipo_novedad' },
          { header: 'Contenido', field: 'novedad' },
        ];
      }
    });

    this.loadData(Constants.NOVEDADES);
    this.loadData(Constants.AVISO_AVERIAS);
    this.loadData(Constants.OT_EJECUTADAS);
    this.loadData(Constants.FUERA_SERVICIO);
    this.loadData(Constants.SEGURIDAD);
    this.loadData(Constants.PERSONAL);
    
  }  

  loadData(type: string): void {

    // Define las áreas que deseas pasar al servicio
    const areas: string[] = [
      Constants.GENERAL,
      Constants.CLORURO_FERRICO,
      Constants.SALMUERA_I,
      Constants.SALMUERA_II,
      Constants.COMPRESION,
      Constants.ELECTROLIZADORES,
      Constants.SUBESTACION,
      Constants.MOVIMIENTO_PRODUCTO,
      Constants.DCS,
    ];
    const isClosed = false;
    const isMarkedForClosure = true;
    const isMarkedForPreClosure = undefined;

    this.updateRecordService
      .getUpdateRecordsByTypeAndAreas(type, areas, isClosed, isMarkedForClosure, isMarkedForPreClosure)
      .subscribe({
        next: (updates: UpdateRecord[]) => {
          const flattened = this.flattenData(updates);
          this.flattenedData[type] = flattened.length ? flattened : [];
        },
        error: error => {
          if (error.status === 404) {
            this.flattenedData[type] = [];
          } else {
            console.error(`Error al cargar los datos para el tipo ${type}:`, error);
            this.flattenedData[type] = [];
          }
        },
      });
  }

  // Determina la marca de cierre a mostrar según rol y/o área del registro
  private getRoleSpecificClosureMark(update: UpdateRecord): boolean {
    const u: any = update as any;
    const areaCode = update.updateArea?.code?.toLowerCase?.() ?? '';
    if (areaCode === 'dcs') {
      return (u.isMarkedForClosureDCS ?? u.isMarkedForClosureDcs ?? update.isMarkedForClosure) as boolean;
    }
    if (areaCode === 'cloruro_ferrico' || areaCode === 'ferrico') {
      return (u.isMarkedForClosureFerrico ?? update.isMarkedForClosure) as boolean;
    }
    return update.isMarkedForClosure;
  }

  flattenData(updates: UpdateRecord[]): any[] {
    return updates.flatMap(update => {
      if(update.id == 303){
        console.log("update: ", update);
      }
      const elements = update.updateElements;
      const getElementValue = (label: string): string =>
        elements.find(el => el.label === label)?.updateValues?.[0]?.value || '';
  
      const hora = getElementValue('Hora');
      const novedad = getElementValue('Novedad');
      const tipoNovedad = getElementValue('Tipo de Novedad');
      const prioridad = getElementValue('Prioridad');
      const queEstaMal = getElementValue('¿Qué está mal?');
      const queTieneDeMalo = getElementValue('¿Qué tiene de malo?');
      const deberia = getElementValue('Debería');
      const nOrden = getElementValue('N° Orden de Trabajo');
      const horaInicio = getElementValue('Hora Inicio');
      const horaTermino = getElementValue('Hora Término');
      const horaPermiso = getElementValue('Hora Permiso Otorgado');
      const enEjecucion = getElementValue('En Ejecución');
      const comentarios = getElementValue('Comentarios');
      const horaFueraServicio = getElementValue('Hora Fuera de Servicio');
      const ingreseNovedad = getElementValue('Ingrese Novedad');
      
  
      // Concatenado general de novedades si no hay un campo explícito "Novedad"
      const detalleNovedad = elements
        .filter(el => el.label !== 'Hora' && el.label !== 'Tipo de Novedad')
        .map(el => {
          const values = el.updateValues?.map(val => `${el.label}: ${val.value}`).join(', ') || '';
          return values || `${el.label}: N/A`;
        })
        .filter(txt => txt.trim() !== '')
        .join(', ');
  
      return {
        id: update.id,
        hora,
        hora_inicio: horaInicio,
        hora_termino: horaTermino,
        hora_permiso: horaPermiso,
        hora_fuera_servicio: horaFueraServicio,
        ingrese_novedad: ingreseNovedad,
        en_ejecucion: enEjecucion,
        n_orden: nOrden,
        prioridad,
        que_esta_mal: queEstaMal,
        que_tiene_de_malo: queTieneDeMalo,
        deberia,
        responsable: elements.find(el => el.element?.id === 2 || el.element?.id === 5)?.updateValues?.[0]?.createdUser?.username || '',
        tipo_novedad: tipoNovedad ? tipoNovedad :  update.updateType?.name,
        tipo: update.updateType?.name,
        area: update.updateArea?.name,
        updateArea: update.updateArea?.name,
        novedad: novedad,
        detalleNovedad,
        comentarios,
        fecha: elements.find(el => el.element?.id === 2 || el.element?.id === 5)?.updateValues?.[0]?.createdUtc || '',
        updateElements: elements,
        updateType: update.updateType,
        isMarkedForClosure: this.getRoleSpecificClosureMark(update),
        isMarkedForPreClosure: update.isMarkedForPreClosure,
        isCloned: update.isCloned,
        
      };
    });
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  viewUpdateRecord(updateRecord: UpdateRecord): void {
    console.log(updateRecord);
    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: updateRecord, // Pasar el objeto directamente
        readOnly: true, // Abrir en modo solo lectura
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  onCheckboxChange(isMarked: boolean, updateRecordId: number): void {
    this.updateRecordService.updateMarkForClosure(updateRecordId, isMarked).subscribe({
      next: () => {
        this.ngOnInit();
        console.log('Estado actualizado correctamente.');
      },
      error: (error) => {
        console.error('Error al actualizar el estado:', error);
      },
    });
  }

  openCloneConfirmation(record: any): void {
    this.recordToClone = record;
    this.showClonePopup = true;
  }

  closeClonePopup(): void {
    this.showClonePopup = false;
    this.recordToClone = null;
  }

  deleteUpdateRecord(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: '¿Estás seguro de que deseas eliminar este registro?' },
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.updateRecordService.deleteUpdateRecord(id).subscribe({
          next: () => {
            console.log(`Registro con ID ${id} eliminado correctamente.`);
            this.ngOnInit();
          },
          error: error => {
            console.error(`Error al eliminar el registro con ID ${id}:`, error);
          },
        });
      }
    });
  }

  editUpdateRecord(updateRecord: any): void {
    if (!updateRecord.updateElements) {
      console.error('El objeto no tiene elementos de actualización:', updateRecord);
      return;
    }

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: updateRecord, // Pasar los datos del registro
        readOnly: false, // Permitir edición
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result: { success: boolean }) => {
      if (result?.success) {
        console.log('Edición realizada con éxito. Actualizando datos...');
        this.ngOnInit();
      }
    });
  }

  confirmClone(): void {
    if (!this.recordToClone) {
      console.error('No hay registro para clonar.');
      return;
    }
  
    this.updateRecordService.cloneUpdateRecord(this.recordToClone.id).subscribe({
      next: clonedRecord => {
        console.log('Registro clonado exitosamente:', clonedRecord);
        // Ejecutar ambas actualizaciones en paralelo y esperar a que ambas terminen
        forkJoin({
          originalUpdate: this.updateRecordService.updateMarkForClosure(this.recordToClone.id, false),
          clonedUpdate: this.updateRecordService.updateMarkForClosure(clonedRecord.id, true)
        }).subscribe({
          next: () => {
            console.log('Ambos estados actualizados correctamente.');
            // Refrescar la vista y cerrar el popup sólo cuando ambas actualizaciones hayan finalizado
            this.ngOnInit();
            this.closeClonePopup();
          },
          error: err => {
            console.error('Error al actualizar los estados:', err);
            this.snackBar.open('Error al actualizar los estados.', 'Cerrar', { duration: 3000 });
          }
        });
      },
      error: err => {
        console.error('Error al clonar el registro:', err);
        this.snackBar.open(err?.error || 'Ocurrió un error al clonar turno.', 'Cerrar', { duration: 3000 });
      }
    });
  }

}
